export const deviceTypes = {
    loading: "LOADING_DEVICE",
    delete: "DELETE_DEVICE",
    loadedOne: "LOADED_DEVICE",
    loadedMultiple: "LOADED_DEVICES",
    success: "SUCCESS_DEVICE",
    restore: "RESTORE_DEVICE",
    hardDelete: "HARDDELETE_DEVICE",
};
